import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"
import _imports_0 from '@/assets/images/user-topic.svg'


const _hoisted_1 = { class: "w-full px-0 cursor-pointer md:px-2" }
const _hoisted_2 = {
  key: 0,
  class: "hidden md:block"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  class: "object-cover w-12 h-12 mr-6 rounded-full cursor-pointer",
  src: _imports_0,
  alt: "user"
}, null, -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = {
  key: 1,
  class: "hidden md:block"
}
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "flex flex-col w-full md:flex-row" }
const _hoisted_8 = { class: "flex flex-col w-full" }
const _hoisted_9 = { class: "text-base font-bold text-black break-all" }
const _hoisted_10 = { class: "min-h-[23px] mt-2 border-l-2 border-h-primary-500" }
const _hoisted_11 = { class: "p-1 text-xs font-semibold bg-neutral-100 w-fit text-h-primary-500 text-wrap" }
const _hoisted_12 = { class: "mt-2 text-sm font-semibold text-neutral-700" }
const _hoisted_13 = { class: "flex items-center justify-between mt-4 md:mt-0 md:ml-6 md:flex-col" }
const _hoisted_14 = { class: "flex items-center self-end gap-2 w-fit h-fit md:mb-4" }
const _hoisted_15 = { class: "pr-4 mr-1 text-base font-bold text-neutral-600" }
const _hoisted_16 = { class: "text-base font-bold text-neutral-600" }
const _hoisted_17 = {
  key: 0,
  class: "flex flex-row items-center self-end px-1 bg-h-success-50 w-fit h-7"
}
const _hoisted_18 = { class: "ml-1 text-xs font-semibold text-h-success-500" }
const _hoisted_19 = {
  key: 1,
  class: "flex flex-row items-center self-end px-1 bg-h-neutral-200 w-fit h-7"
}
const _hoisted_20 = { class: "ml-1 text-xs font-semibold text-h-neutral-800" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("a", {
      class: "flex flex-row pb-6 mt-6 border-b md:flex-row border-neutral-400 md:justify-between",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goToTopicDetail && _ctx.goToTopicDetail(...args)))
    }, [
      (!_ctx.topic.userAuthor.photoProfile)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
        : (_ctx.topic.userAuthor.photoProfile)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("img", {
                class: "object-cover w-12 h-12 mr-6 rounded-full cursor-pointer",
                src: _ctx.topic.userAuthor.photoProfile.path,
                alt: "user"
              }, null, 8, _hoisted_6)
            ]))
          : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("main", _hoisted_8, [
          _createElementVNode("h6", _hoisted_9, _toDisplayString(_ctx.topic.title), 1),
          _createElementVNode("span", _hoisted_10, [
            _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.topic.tag), 1)
          ]),
          _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.$t("labels.generic", {
                pt: "Publicado",
                en: "Published",
              })) + " " + _toDisplayString(_ctx.timeSinceCreation) + " " + _toDisplayString(_ctx.$t("labels.generic", {
                pt: "por",
                en: "by",
              })) + " " + _toDisplayString(_ctx.topic.userAuthor.name), 1)
        ]),
        _createElementVNode("footer", _hoisted_13, [
          _createElementVNode("span", _hoisted_14, [
            _createVNode(_component_v_icon, {
              name: "md-chatbubbleoutline-round",
              class: "text-neutral-600",
              scale: "1.3"
            }),
            _createElementVNode("p", _hoisted_15, _toDisplayString(_ctx.topic.commentAmount), 1),
            _createVNode(_component_v_icon, {
              name: "pr-thumbs-up",
              scale: "1.3",
              class: "text-neutral-600"
            }),
            _createElementVNode("p", _hoisted_16, _toDisplayString(_ctx.topic.likeAmount), 1)
          ]),
          (_ctx.topic.status === _ctx.status.SOLVED)
            ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                _createVNode(_component_v_icon, {
                  name: "md-check-round",
                  scale: "0.9",
                  class: "text-h-success-500"
                }),
                _createElementVNode("p", _hoisted_18, _toDisplayString(_ctx.$t("labels.generic", {
                  pt: "RESOLVIDO",
                  en: "SOLVED",
                })), 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.topic.status  === _ctx.status.CLOSED)
            ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                _createVNode(_component_v_icon, {
                  name: "io-checkmark",
                  scale: "0.9"
                }),
                _createElementVNode("p", _hoisted_20, _toDisplayString(_ctx.$t("labels.generic", {
                  pt: "ENCERRADO",
                  en: "CLOSED",
                })), 1)
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}